import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  setSelectedId,
  setSpeakerPostnDrivethru,
  setDriveThru
} from '../../redux/reducers/models.js'

import '../../styles/components/Render3DComponent.scss'

const Render3DComponent = () => {
  const {
    screens,
    arStarted,
    step,
    speakerOption,
    canopy,
    speakerPostnDrivethru,
    driveThru
  } = useSelector((state) => state.models)
  const dispatch = useDispatch()

  const step2Classes = speakerPostnDrivethru
    ? ['Option3Screen1', 'Option3Screen2', 'Option3Screen3']
    : ['Screen1Gif', 'Screen2Gif', 'Screen3Gif']
  const canopyClasses = speakerPostnDrivethru
    ? ['CanopyV1', 'CanopyV2', 'CanopyV3']
    : ['Canopy1S', 'Canopy2S', 'Canopy3S']

  const imgClasses = [...step2Classes, ...canopyClasses]

  const optionClasses = ['Option1', 'Option2', 'Option3']

  useEffect(() => {
    switch (speakerOption) {
      case 1:
        dispatch(setSelectedId(0))
        dispatch(setSpeakerPostnDrivethru(false))
        dispatch(setDriveThru(false))
        break
      case 2:
        dispatch(setSelectedId(1))
        dispatch(setSpeakerPostnDrivethru(false))
        dispatch(setDriveThru(true))
        break
      case 3:
        dispatch(setSelectedId(2))
        dispatch(setSpeakerPostnDrivethru(true))
        dispatch(setDriveThru(false))
        break
      default:
        dispatch(setSelectedId(0))
        break
    }
  }, [speakerOption])

  const classSwitcher = () => {
    switch (step) {
      case 1:
        return optionClasses[speakerOption - 1]
      case 2:
        return imgClasses[screens - 1]
      case 3:
        return imgClasses[screens - 1]
      default:
        return 1
    }
  }

  useEffect(() => {
    if (speakerPostnDrivethru && step === 3) {
      if (canopy && screens === 4) {
        dispatch(setSelectedId(10))
      } else if (!canopy && screens === 1) {
        dispatch(setSelectedId(9))
      }

      if (canopy && screens === 5) {
        dispatch(setSelectedId(11))
      } else if (!canopy && screens === 2) {
        dispatch(setSelectedId(2))
      }

      if (canopy && screens === 6) {
        dispatch(setSelectedId(12))
      } else if (!canopy && screens === 3) {
        dispatch(setSelectedId(13))
      }
    }

    if (driveThru && step === 3) {
      if (canopy && screens === 4) {
        dispatch(setSelectedId(3))
      } else if (!canopy && screens === 1) {
        dispatch(setSelectedId(6))
      }

      if (canopy && screens === 5) {
        dispatch(setSelectedId(4))
      } else if (!canopy && screens === 2) {
        dispatch(setSelectedId(1))
      }

      if (canopy && screens === 6) {
        dispatch(setSelectedId(5))
      } else if (!canopy && screens === 3) {
        dispatch(setSelectedId(8))
      }
    }
  }, [canopy, step])

  return (
    <div className='canvas' data-testid='canvas'>
      <div
        style={arStarted ? { marginTop: '-30px' } : {}}
        className={`canvas__img ${classSwitcher()}`}
      />
    </div>
  )
}

export default Render3DComponent
